module.exports = __webpack_public_path__ + "img/asesoria_tecnica_en_construccion.d4a170be.png";